import React, { useEffect, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { fetchOrderRecommend } from "../../../../../../../api";
import { Products } from "../../../../../listing/components/list";
import { FormattedMessage } from "react-intl";

const ConfirmRecommend = props =>{
    useStyles(cls);
    const { transaction } = props;
    const [products, setProducts] = useState(null);

    useEffect(async () =>{
        let products = await fetchOrderRecommend({ skip: 0, orderId: transaction?.id }).then(response=>{
            const productItems = response?.result?.map(p => ({
                ...p,
                geekoRequsestId: response.requestId,
                geekoExperimentId: response.experimentId,
                layerName: response.layerName,
                trackingRecords: response.trackingRecords
            }))
            return productItems || [];
        }).catch(error=>[]);
        setProducts(products);
    }, []);

    return <React.Fragment>
        {
            products?.length > 0 && <div className={cls.ConfirmRecommend}>
                <div className={cls.Hd}>
                    <FormattedMessage id="often_bought_with" defaultMessage="OFTEN BOUGHT WITH" />
                </div>

                <div className={cls.Bd}>
                    <Products 
                       products={products} 
                    />
                </div>
            </div>
        }
    </React.Fragment>
}

export default ConfirmRecommend;